import React from 'react'
import { sanitizeHTML } from '../../../../shared/utils/common-utils'

/**
 * The AssetAllocation component displays a header, subhead, and figure. The figure
 * has two annotation regions where text is overlayed over the top of the image. On medium
 * and smaller screens the annotations are moved below the image.
 *
 * @returns a component
 */
export default function AssetAllocation(props) {
  let introduction = ''
  let topLeftAnnotation = ''
  let bottomRightAnnotation = ''
  let imageAlt = ''
  let imageContent = ''

  if (props) {
    introduction = props.contentIntroduction
    topLeftAnnotation = props.contentTopLeft
    bottomRightAnnotation = props.contentBottomRight
    imageAlt = props.contentImageAlt
    imageContent = props.imageContent
  }

  return (
    <div
      id='asset-allocation'
      className='asset-allocation-wrapper u-sizeConstrained u-padding8gu u-bgColorLight'>
      <div className='asset-allocation-content Grid Grid--alignCenter u-bgColorWhite u-sizeConstrained'>
        {props && (
          <>
            <div
              className='u-padding8gu u-size3of4 introduction'
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(introduction) }}></div>
            <figure className='u-padding8gu u-textPrimary asset-allocation'>
              <figcaption className='print-force-background u-textCenter u-marginBottom4gu'></figcaption>
              <div className='u-sm-sizeFull u-md-sizeFull u-lg-sizeFull annotation-container'>
                <img
                  className='u-sm-sizeFull u-md-sizeFull u-lg-sizeFull'
                  src={imageContent.trim()}
                  alt={imageAlt.trim()}
                />
                <div
                  className='u-sm-hidden u-md-hidden u-pt-hidden annotation top-left u-bgColorBrand'
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTML(topLeftAnnotation),
                  }}></div>
                <div
                  className='u-sm-hidden u-md-hidden u-pt-hidden annotation bottom-right u-bgColorBrand'
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTML(bottomRightAnnotation),
                  }}></div>
                <div className='graph-tooltip graph-tooltip-left u-posAbsolute u-bgColorBrand u-lg-hidden u-marginVert4gu Card'>
                  <div
                    className='Card-body u-textPrimary annotation-card'
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHTML(topLeftAnnotation),
                    }}></div>
                </div>
                <div className='graph-tooltip graph-tooltip-right u-posAbsolute u-bgColorBrand u-lg-hidden u-marginVert4gu Card'>
                  <div
                    className='Card-body u-textPrimary annotation-card'
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHTML(bottomRightAnnotation),
                    }}></div>
                </div>
              </div>
            </figure>
          </>
        )}
      </div>
    </div>
  )
}
